module.exports = __webpack_public_path__ + "static/media/tw.605156c5.svg";